(function() {
  'use strict';

  // ═══════════════════════════════════════════
  // CONFIG
  // ═══════════════════════════════════════════
  var ALL_CHIP_TYPES = [
    'butterfly','bunny','giraffe','horse','rainbow',
    'star','heart','balloon','cloud','gift','sun','book',
    'desk','blocks','table','cushion','sofa'
  ];
  var SIZE_RANGE = { min: 22, max: 50 };
  var OPACITY_RANGE = { min: 0.28, max: 0.50 };
  var DRIFT_DURATION = { min: 8000, max: 16000 };
  var DRIFT_RADIUS = { min: 25, max: 55 };
  var CHIPS_PER_SECTION = { desktop: 6, mobile: 2 };
  var MIN_CHIP_SPACING = 90; // Minimum px between any two chips for cleaner look
  var CONTENT_PAD = 24;      // Padding around content elements to avoid overlap

  var SKIP_SELECTORS = [
    '.slideshow', '[class*="slideshow"]',
    '.tlf-canvas', '.tlf-chips'
  ];
  // Base chips per section; the actual count scales up with section height so tall
  // sections (long product grids, hero/gallery bands) get filled instead of
  // staying sparse. A single all-products grid can be several thousand px tall,
  // so the cap is generous.
  var CHIPS_CAP = { desktop: 28, mobile: 10 };
  var CHIPS_PER_PX = 350; // one extra chip per ~350px of section height
  var CONTENT_SELECTORS = [
    'img', 'video', 'h1', 'h2', 'h3', 'p', 'a.button', 'button',
    '.card', '.grid__item', '.product-card', '.collection-card',
    'form', 'input', 'textarea', 'select',
    '.banner', '.image-with-text__media-item',
    '.multicolumn-card', '.rich-text', '.title',
    // Header / nav so chips never crowd the logo, menu or cart/account icons
    '.header__heading', '.header__icons', '.header__icon',
    'nav', '.header__inline-menu', '.list-menu__item', 'summary',
    // Custom TLF section content blocks so chips fill the gutters/empty bands
    // around them instead of landing on a card or text column.
    '.tlf-hero__content', '.tlf-statement__text-col', '.tlf-statement__image-col',
    '.tlf-feature-grid__card', '.tlf-process__step', '.tlf-gallery__item',
    '.tlf-categories__item', '.tlf-features__item', '.tlf-testimonials__wrapper',
    '.tlf-consultation__inner', '.tlf-spaces__content', '.tlf-about__value',
    '.tlf-about__story-media', '.tlf-about__founder-frame', '.tlf-marquee__item'
  ];

  var templates = document.getElementById('tlf-svg-templates');
  if (!templates) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // ═══════════════════════════════════════════
  // HELPERS
  // ═══════════════════════════════════════════
  function rand(a, b) { return Math.random() * (b - a) + a; }
  function randInt(a, b) { return Math.floor(rand(a, b + 1)); }
  function isMobile() { return window.innerWidth < 750; }

  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
    return arr;
  }

  function shouldSkipSection(el) {
    for (var i = 0; i < SKIP_SELECTORS.length; i++) {
      if (el.matches && el.matches(SKIP_SELECTORS[i])) return true;
      if (el.querySelector && el.querySelector(SKIP_SELECTORS[i])) return true;
    }
    if (el.offsetHeight < 120) return true;
    return false;
  }

  function getContentRects(section) {
    var rects = [];
    var sRect = section.getBoundingClientRect();
    for (var i = 0; i < CONTENT_SELECTORS.length; i++) {
      var els = section.querySelectorAll(CONTENT_SELECTORS[i]);
      for (var j = 0; j < els.length; j++) {
        var r = els[j].getBoundingClientRect();
        if (r.width > 0 && r.height > 0) {
          rects.push({
            left: r.left - sRect.left,
            top: r.top - sRect.top,
            right: r.right - sRect.left,
            bottom: r.bottom - sRect.top,
            width: r.width,
            height: r.height
          });
        }
      }
    }
    return rects;
  }

  function overlapsContent(x, y, size, contentRects) {
    for (var i = 0; i < contentRects.length; i++) {
      var c = contentRects[i];
      // Check with generous padding around content
      if (x + size + CONTENT_PAD > c.left &&
          c.right + CONTENT_PAD > x &&
          y + size + CONTENT_PAD > c.top &&
          c.bottom + CONTENT_PAD > y) {
        return true;
      }
    }
    return false;
  }

  function distToNearest(x, y, placed) {
    var minDist = Infinity;
    for (var p = 0; p < placed.length; p++) {
      var dx = x - placed[p].x;
      var dy = y - placed[p].y;
      var d = Math.sqrt(dx * dx + dy * dy);
      if (d < minDist) minDist = d;
    }
    return minDist;
  }

  // ═══════════════════════════════════════════
  // EDGE-PREFERRING PLACEMENT
  // Chips prefer edges and corners of sections
  // for a cleaner, more arranged aesthetic
  // ═══════════════════════════════════════════
  function generateEdgePosition(sW, sH, size, margin) {
    var edge = Math.floor(Math.random() * 4);
    var x, y;
    switch (edge) {
      case 0: // top edge
        x = rand(margin, sW - size - margin);
        y = rand(margin, Math.min(sH * 0.2, 100));
        break;
      case 1: // bottom edge
        x = rand(margin, sW - size - margin);
        y = rand(Math.max(sH * 0.8, sH - 100), sH - size - margin);
        break;
      case 2: // left edge
        x = rand(margin, Math.min(sW * 0.15, 120));
        y = rand(margin, sH - size - margin);
        break;
      case 3: // right edge
        x = rand(Math.max(sW * 0.85, sW - 120), sW - size - margin);
        y = rand(margin, sH - size - margin);
        break;
    }
    return { x: Math.max(margin, x), y: Math.max(margin, Math.min(y, sH - size - margin)) };
  }

  function findSafePositions(section, count) {
    var sW = section.offsetWidth;
    var sH = section.offsetHeight;
    var contentRects = getContentRects(section);
    var positions = [];
    var placed = [];
    var margin = 16;

    for (var attempt = 0; attempt < count; attempt++) {
      var size = randInt(SIZE_RANGE.min, SIZE_RANGE.max);
      var bestPos = null;
      var bestDist = 0;

      // Try many candidates, pick the one furthest from existing chips
      for (var tries = 0; tries < 60; tries++) {
        var pos;
        // 70% chance: edge-preferring, 30% chance: anywhere
        if (Math.random() < 0.7) {
          pos = generateEdgePosition(sW, sH, size, margin);
        } else {
          pos = {
            x: rand(margin, sW - size - margin),
            y: rand(margin, sH - size - margin)
          };
        }

        // Must not overlap content
        if (overlapsContent(pos.x, pos.y, size, contentRects)) continue;

        // Check spacing from other chips
        var dist = placed.length === 0 ? 9999 : distToNearest(pos.x, pos.y, placed);
        if (dist < MIN_CHIP_SPACING) continue;

        // Keep the best candidate (most spread out)
        if (dist > bestDist) {
          bestDist = dist;
          bestPos = { x: pos.x, y: pos.y, size: size };
        }
      }

      if (bestPos) {
        positions.push(bestPos);
        placed.push({ x: bestPos.x, y: bestPos.y });
      }
    }
    return positions;
  }

  // ═══════════════════════════════════════════
  // MAIN: SCAN SECTIONS & PLACE CHIPS
  // ═══════════════════════════════════════════
  var allChips = [];
  var chipTypeIndex = 0;
  var shuffledTypes = shuffle(ALL_CHIP_TYPES.slice());

  function getNextChipType() {
    var type = shuffledTypes[chipTypeIndex % shuffledTypes.length];
    chipTypeIndex++;
    return type;
  }

  function createChipElement(chipType, size, opacity, rotation) {
    var svgTpl = templates.querySelector('[data-chip="' + chipType + '"]');
    if (!svgTpl) return null;

    var el = document.createElement('div');
    el.className = 'tlf-roaming-chip';
    el.style.width = size + 'px';
    el.style.height = size + 'px';
    el.style.opacity = opacity.toFixed(2);
    el.style.left = '0px';
    el.style.top = '0px';
    el.appendChild(svgTpl.cloneNode(true));
    return el;
  }

  function placeChipsInSections(opts) {
    opts = opts || {};
    // The header & footer chips don't depend on lazy body images, so the deferred
    // "settle" re-runs keep them as-is (rebuilding them re-randomises the navbar,
    // which looked like the chips suddenly changing on every page load).
    var redoFixed = opts.includeFixed !== false;

    // Clean up existing chips. When we're not redoing the fixed (header/footer)
    // chips, keep them in place and only clear the body section chips.
    var kept = [];
    allChips.forEach(function(c) {
      var isFixed = c.isHeader || (c.el && c.el.classList && c.el.classList.contains('tlf-footer-chip'));
      if (isFixed && !redoFixed) {
        kept.push(c);
      } else if (c.el && c.el.parentNode) {
        c.el.parentNode.removeChild(c.el);
      }
    });
    allChips = kept;
    chipTypeIndex = 0;
    shuffledTypes = shuffle(ALL_CHIP_TYPES.slice());

    // Find the main content wrapper
    var mainContent = document.getElementById('MainContent');
    if (!mainContent) mainContent = document.querySelector('main') || document.body;

    // Ensure chips container
    var container = document.getElementById('tlf-chips-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'tlf-chips-container';
      container.className = 'tlf-chips';
      container.setAttribute('aria-hidden', 'true');
      mainContent.appendChild(container);
    } else if (container.parentNode !== mainContent) {
      mainContent.appendChild(container);
    }
    container.innerHTML = '';

    // Get all shopify sections inside main
    var sections = mainContent.querySelectorAll('.shopify-section');
    if (!sections.length) sections = mainContent.children;

    var mobile = isMobile();
    var base = mobile ? CHIPS_PER_SECTION.mobile : CHIPS_PER_SECTION.desktop;
    var cap = mobile ? CHIPS_CAP.mobile : CHIPS_CAP.desktop;

    for (var i = 0; i < sections.length; i++) {
      var section = sections[i];
      if (shouldSkipSection(section)) continue;

      // Scale density with the section's height so big empty bands fill out and
      // long product grids don't end up nearly empty; short bands stay calm.
      var heightBonus = Math.floor(section.offsetHeight / CHIPS_PER_PX);
      var perSection = Math.min(cap, base + heightBonus);

      // Calculate offset relative to MainContent
      var actualOffsetTop = section.offsetTop;
      var parent = section.offsetParent;
      while (parent && parent !== mainContent && parent !== document.body) {
        actualOffsetTop += parent.offsetTop;
        parent = parent.offsetParent;
      }
      var sRect = section.getBoundingClientRect();
      var mainRect = mainContent.getBoundingClientRect();
      var sOffsetLeft = sRect.left - mainRect.left;

      var positions = findSafePositions(section, perSection);

      for (var j = 0; j < positions.length; j++) {
        var pos = positions[j];
        var chipType = getNextChipType();
        var opacity = rand(OPACITY_RANGE.min, OPACITY_RANGE.max);
        var rotation = rand(-10, 10);
        var absX = sOffsetLeft + pos.x;
        var absY = actualOffsetTop + pos.y;

        var el = createChipElement(chipType, pos.size, opacity, rotation);
        if (!el) continue;

        el.style.transform = 'translate(' + absX.toFixed(1) + 'px,' + absY.toFixed(1) + 'px) rotate(' + rotation.toFixed(1) + 'deg)';
        container.appendChild(el);

        allChips.push({
          el: el,
          size: pos.size,
          x: absX, y: absY,
          homeX: absX, homeY: absY,
          rotation: rotation,
          targetX: absX, targetY: absY,
          targetRotation: rotation,
          startX: absX, startY: absY,
          startRotation: rotation,
          animStart: performance.now() - rand(0, 20000),
          animDuration: rand(DRIFT_DURATION.min, DRIFT_DURATION.max),
          baseOpacity: opacity,
          driftRadius: rand(DRIFT_RADIUS.min, DRIFT_RADIUS.max)
        });
      }
    }

    // Place header & footer chips (both live outside #MainContent). Skipped on the
    // deferred settle re-runs so the navbar chips stay stable across page loads.
    if (redoFixed) {
      placeHeaderChips();
      placeFooterChips();
    }
  }

  // ═══════════════════════════════════════════
  // FOOTER CHIPS — subtle, gutter-confined
  // The footer sits outside #MainContent, so it gets its own pass. Chips stay in
  // the left/right gutters and corners and never overlap the footer content.
  // ═══════════════════════════════════════════
  function placeFooterChips() {
    var footer = document.querySelector('.tlf-footer') ||
                 document.querySelector('.shopify-section--footer footer') ||
                 document.querySelector('footer');
    if (!footer) return;

    var oldChips = footer.querySelectorAll('.tlf-footer-chip');
    for (var k = 0; k < oldChips.length; k++) {
      oldChips[k].parentNode.removeChild(oldChips[k]);
    }

    if (getComputedStyle(footer).position === 'static') {
      footer.style.position = 'relative';
    }
    var fRect = footer.getBoundingClientRect();
    if (fRect.height < 120) return;

    var count = isMobile() ? 2 : 5;
    var contentRects = getContentRects(footer);
    var fW = footer.offsetWidth;
    var fH = footer.offsetHeight;
    var placed = [];
    var margin = 16;

    for (var i = 0; i < count; i++) {
      var size = randInt(20, 40);

      for (var tries = 0; tries < 60; tries++) {
        // Footer chips hug the left/right gutters only.
        var x = (i % 2 === 0)
          ? rand(margin, Math.max(margin, fW * 0.12))
          : rand(fW * 0.88, fW - size - margin);
        var y = rand(margin, fH - size - margin);

        if (overlapsContent(x, y, size, contentRects)) continue;
        if (placed.length && distToNearest(x, y, placed) < MIN_CHIP_SPACING) continue;

        var chipType = getNextChipType();
        var opacity = rand(0.20, 0.34);
        var rotation = rand(-10, 10);

        var el = createChipElement(chipType, size, opacity, rotation);
        if (!el) continue;

        el.className += ' tlf-footer-chip';
        // left/top stay at 0 (set in createChipElement); transform carries the
        // absolute position so the drift animation loop can take over cleanly.
        el.style.zIndex = '0';
        el.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) rotate(' + rotation.toFixed(1) + 'deg)';
        footer.appendChild(el);
        placed.push({ x: x, y: y });

        allChips.push({
          el: el, size: size,
          x: x, y: y, homeX: x, homeY: y,
          rotation: rotation,
          targetX: x, targetY: y, targetRotation: rotation,
          startX: x, startY: y, startRotation: rotation,
          animStart: performance.now() - rand(0, 18000),
          animDuration: rand(DRIFT_DURATION.min, DRIFT_DURATION.max),
          baseOpacity: opacity,
          driftRadius: rand(DRIFT_RADIUS.min, DRIFT_RADIUS.max)
        });
        break;
      }
    }
  }

  // ═══════════════════════════════════════════
  // HEADER CHIPS — Rendered inside header element
  // ═══════════════════════════════════════════
  function placeHeaderChips() {
    var header = document.querySelector('.section-header');
    if (!header) return;

    // Clean previous header chips
    var oldChips = header.querySelectorAll('.tlf-header-chip');
    for (var k = 0; k < oldChips.length; k++) {
      oldChips[k].parentNode.removeChild(oldChips[k]);
    }

    // Ensure header is positioning context
    var hStyle = getComputedStyle(header);
    if (hStyle.position === 'static') {
      header.style.position = 'relative';
    }

    var headerWrapper = header.querySelector('.header-wrapper') || header;
    var hRect = headerWrapper.getBoundingClientRect();
    var sRect = header.getBoundingClientRect();
    if (hRect.height < 40) return;

    // Avoid the nav menu, the right-hand icons AND the logo, so the floating
    // chips decorate the empty header space without blocking the logo.
    var headerAvoid = ['.header__heading', '.header__heading-logo-wrapper',
                       '.header__icons', '.header__icon', '.header__search',
                       'nav', '.header__inline-menu', '.list-menu__item', 'summary'];
    var wRect = headerWrapper.getBoundingClientRect();
    var contentRects = [];
    for (var ai = 0; ai < headerAvoid.length; ai++) {
      var aEls = headerWrapper.querySelectorAll(headerAvoid[ai]);
      for (var aj = 0; aj < aEls.length; aj++) {
        var ar = aEls[aj].getBoundingClientRect();
        if (ar.width > 0 && ar.height > 0) {
          contentRects.push({
            left: ar.left - wRect.left, top: ar.top - wRect.top,
            right: ar.right - wRect.left, bottom: ar.bottom - wRect.top,
            width: ar.width, height: ar.height
          });
        }
      }
    }

    // Reserve the far-left strip too: when the header is scrolled the logo slides
    // down to the LEFT, so keep chips out of that zone — otherwise a chip that was
    // happily sitting in the (empty) left area ends up on top of the scrolled logo.
    var leftReserve = isMobile() ? 110 : 170;
    contentRects.push({
      left: 0, top: 0, right: leftReserve, bottom: hRect.height,
      width: leftReserve, height: hRect.height
    });

    var count = isMobile() ? 3 : 7;
    var headerPlaced = [];

    // Offset: chips positioned relative to section-header
    var offsetX = hRect.left - sRect.left;
    var offsetY = hRect.top - sRect.top;

    // Size chips relative to the header height so they're nice and big on the
    // full-size navbar and naturally smaller on a shorter (mobile) bar. The
    // CSS scale on `.scrolled-past-header` then shrinks them smoothly on scroll.
    // These small accent shapes look better a touch smaller in the navbar.
    var SMALL_HEADER_CHIPS = { balloon: 1, sun: 1, heart: 1, gift: 1, star: 1, book: 1 };
    var hHeight = hRect.height;
    for (var i = 0; i < count; i++) {
      var chipType = getNextChipType();
      var size = Math.round(Math.min(46, Math.max(22, hHeight * rand(0.4, 0.52))));
      if (SMALL_HEADER_CHIPS[chipType]) {
        size = Math.round(Math.max(16, size * 0.72));
      }

      for (var tries = 0; tries < 60; tries++) {
        var x = rand(8, Math.max(10, hRect.width - size - 8));
        var y = rand(4, Math.max(4, hRect.height - size - 4));

        if (overlapsContent(x, y, size, contentRects)) continue;

        var tooClose = false;
        for (var p = 0; p < headerPlaced.length; p++) {
          var dx = x - headerPlaced[p].x;
          var dy = y - headerPlaced[p].y;
          if (Math.sqrt(dx * dx + dy * dy) < 46) { tooClose = true; break; }
        }
        if (tooClose) continue;

        var opacity = rand(0.25, 0.42);
        var rotation = rand(-8, 8);

        var el = createChipElement(chipType, size, opacity, rotation);
        if (!el) continue;

        // Position inside the header using percentages so it scales with scroll
        var pLeft = (((offsetX + x) / sRect.width) * 100).toFixed(2) + '%';
        var pTop = (((offsetY + y) / sRect.height) * 100).toFixed(2) + '%';

        el.className = 'tlf-header-chip';
        el.style.position = 'absolute';
        el.style.zIndex = '0';
        el.style.pointerEvents = 'none';
        el.style.width = size + 'px';
        el.style.height = size + 'px';
        el.style.left = pLeft;
        el.style.top = pTop;
        el.style.rotate = rotation.toFixed(1) + 'deg';
        el.style.willChange = 'translate, rotate, scale';
        // Drift uses translate/rotate; the scroll-shrink uses the `scale` property
        // (handled in base.css). Leave transition to base.css so scale eases.
        header.appendChild(el);

        headerPlaced.push({ x: x, y: y });

        allChips.push({
          el: el,
          size: size,
          x: 0, y: 0, // Current drift offset
          homeX: 0, homeY: 0, // Drift home is 0,0
          rotation: rotation,
          targetX: 0, targetY: 0,
          targetRotation: rotation,
          startX: 0, startY: 0,
          startRotation: rotation,
          animStart: performance.now() - rand(0, 15000),
          animDuration: rand(5000, 10000),
          baseOpacity: opacity,
          driftRadius: rand(9, 16),
          isHeader: true
        });
        break;
      }
    }
  }

  // ═══════════════════════════════════════════
  // ANIMATION LOOP
  // ═══════════════════════════════════════════
  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function setNewTarget(c) {
    c.startX = c.x;
    c.startY = c.y;
    c.startRotation = c.rotation;
    var angle = rand(0, Math.PI * 2);
    var r = rand(c.driftRadius * 0.3, c.driftRadius);
    c.targetX = c.homeX + Math.cos(angle) * r;
    c.targetY = c.homeY + Math.sin(angle) * r;
    c.targetRotation = Math.max(-12, Math.min(12, c.rotation + rand(-3, 3)));
    c.animStart = performance.now();
    c.animDuration = rand(DRIFT_DURATION.min, DRIFT_DURATION.max);
  }

  function animate(now) {
    for (var i = 0; i < allChips.length; i++) {
      var c = allChips[i];
      var elapsed = now - c.animStart;
      var progress = Math.min(elapsed / c.animDuration, 1);
      var eased = easeInOutCubic(progress);

      c.x = c.startX + (c.targetX - c.startX) * eased;
      c.y = c.startY + (c.targetY - c.startY) * eased;
      c.rotation = c.startRotation + (c.targetRotation - c.startRotation) * eased;

      if (c.isHeader) {
        // Header chips: drift via translate around percentage anchor
        c.el.style.translate = c.x.toFixed(1) + 'px ' + c.y.toFixed(1) + 'px';
        c.el.style.rotate = c.rotation.toFixed(1) + 'deg';
      } else {
        c.el.style.transform = 'translate(' + c.x.toFixed(1) + 'px,' + c.y.toFixed(1) + 'px) rotate(' + c.rotation.toFixed(1) + 'deg)';
      }

      if (progress >= 1) setNewTarget(c);
    }
    requestAnimationFrame(animate);
  }

  // ═══════════════════════════════════════════
  // INIT
  // ═══════════════════════════════════════════
  var animating = false;
  function placeAndAnimate(opts) {
    placeChipsInSections(opts);
    if (allChips.length && !animating) { animating = true; requestAnimationFrame(animate); }
  }
  function init() {
    placeAndAnimate();
    // Re-measure ONLY the body sections after late-loading images settle the
    // layout (product grids, lazy images). The header/footer chips are left
    // untouched so the navbar doesn't visibly re-shuffle on each page load.
    setTimeout(function () { placeAndAnimate({ includeFixed: false }); }, 1800);
    setTimeout(function () { placeAndAnimate({ includeFixed: false }); }, 4000);
  }

  if (document.readyState === 'complete') {
    setTimeout(init, 600);
  } else {
    window.addEventListener('load', function() { setTimeout(init, 600); });
  }

  // Handle resize
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(placeChipsInSections, 400);
  });

})();
